import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { BillingRoutes } from "../../constants/billing/billing.constants";
import { BillingAccount } from "../../models/billing/billing.models";

@autoinject
export class BillingAccountService {
    constructor(private requestClient: RequestClientService) { }

    public getBillingAccountById(id: number): Promise<BillingAccount> {
        return this.requestClient.get(`${BillingRoutes.GetBillingAccountById}/${id}`, {});
    }

    public getExistingBillingAccountForInspection(inspectionId: number, vesselId: number): Promise<any> {
        return this.requestClient.get(`${BillingRoutes.GetInspectionExistingBillingDetails}/${inspectionId}/${vesselId}`, {});
    }
}